var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#e59124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e59124;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "18-paper",
    id: "_18-paper"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,5V3a2,2,0,0,0-2-2H7A2,2,0,0,0,5,3V29a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14,
    x2: 18,
    y1: 27,
    y2: 27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.75 19.25 19 20 19.75 16.25 28 8 31 11 22.75 19.25"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16,
    x2: 9,
    y1: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9,
    x2: 17,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9,
    x2: 19,
    y1: 12,
    y2: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.d805e622ffb8dad1d9f832876b47ca85.svg";
export { ForwardRef as ReactComponent };